export default __webpack_public_path__ + "static/media/Intro (1).59276f67.jpg";